var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZenon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7701 6H8.5V7.64881H13.7704L8.52803 10.8626V19.1625H9.98581V15.0265L15.3123 19.1346H16.7981V18.2962V18.1564V11.1141H11.2754L16.7981 7.59291V6H16.7701ZM15.2562 12.707L15.2843 16.9548L9.95777 12.707H15.2562Z",
    fill: "url(#paint0_linear_454_1060)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_454_1060",
    x1: 12.649,
    y1: 6,
    x2: 12.649,
    y2: 19.1625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67E646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40BF21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenon);
export default __webpack_public_path__ + "static/media/zenon.cd6d449269ff8c4da46a625a75881150.svg";
export { ForwardRef as ReactComponent };